import { AsistenteEnLineaUtils } from './../../../../utils/asistente-en-linea.utils';
import { VentanaUtils } from '../../../../utils/ventana.utils';
import { Component, OnInit, Input, AfterViewInit, ViewChild, ViewChildren,
  QueryList, ElementRef, EventEmitter, Output } from '@angular/core';
import { Message } from './../../models/message';
import { MessageItemComponent } from '../message-item/message-item.component';


import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../../confirm-modal/confirm-modal.component';
import { LocalStorageService } from 'src/app/asistente-en-linea/services/local-storage.service';
import { HandlerType } from 'src/app/asistente-en-linea/models/HandlerType';

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.scss']
})
export class MessageListComponent implements OnInit, AfterViewInit {

  @Input() messages: Message[];
  @ViewChild('chatlist',  {read: ElementRef, static: true} ) chatList: ElementRef;
  @ViewChildren(MessageItemComponent, { read: ElementRef }) chatItems: QueryList<MessageItemComponent>;

  public minimized = false;
  handlerType = new HandlerType();

  constructor(public utils: AsistenteEnLineaUtils,
              public dialog: MatDialog,
              public window: VentanaUtils,
              private localstorage: LocalStorageService) { }

  ngAfterViewInit() {
    this.chatItems.changes.subscribe(elements => {
      this.scrollToBottom();
    });
  }

  private scrollToBottom(): void {
    try {
      this.chatList.nativeElement.scrollTop = this.chatList.nativeElement.scrollHeight;
    } catch (err) {
      console.log('Could not find the "chatList" element.');
    }
  }

  ngOnInit() {
    this.localstorage.setWindowStatus('max');
    this.handlerType.chat = true;
    this.handlerType.email = false;
  }

}
